export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9282.35b1d83c.jpg";